import Loader from 'components/atoms/Loader/Loader';
import { appSwitchRoutes } from 'constants/routes';
import { useAiInterviewRoleStageQuery } from 'generated/graphql';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Sends the AI interview's old `/ai-interview/:id` address to its current
 * home under the role and stage. Only tabs and history entries opened before
 * the move reach this; the stage card links straight to the new URL.
 */
export function AiInterviewLegacyRedirect() {
  const params = useParams();
  const actionCandidateId =
    params.aiInterviewAssessmentStageActionCandidateId ?? '';

  const { data, error } = useAiInterviewRoleStageQuery({
    variables: { id: actionCandidateId },
    skip: !actionCandidateId,
  });

  if (!actionCandidateId || error) {
    return <Navigate replace to={appSwitchRoutes.roles.getUrl()} />;
  }

  const roleStage = data?.aiInterviewAssessmentStageActionCandidateRoleStage;
  if (!roleStage) {
    return <Loader />;
  }

  return (
    <Navigate
      replace
      to={appSwitchRoutes.aiInterview.getUrl(
        roleStage.roleId,
        roleStage.stageId,
        actionCandidateId
      )}
    />
  );
}
